import '@presentation/components/Modal';
import { enhanceSearchableSelects } from '@presentation/components/SearchableSelect';
import { dismissFormModals } from '@presentation/shell/viewDom';

type ModalEl = HTMLElement & { open: () => void; close: () => void };

/** Ouvre une modale, rend le formulaire dans l'hôte, et retire le nœud à la fermeture. */
export function openFormModal(
  parent: HTMLElement,
  opts: { title: string; size?: 'sm' | 'md' | 'lg' | 'xl' },
  render: (host: HTMLElement, close: () => void) => void,
): void {
  dismissFormModals(parent);
  const modal = document.createElement('nexxus-modal') as ModalEl;
  modal.setAttribute('title', opts.title);
  modal.setAttribute('size', opts.size ?? 'lg');
  modal.setAttribute('data-form-modal', '');
  const host = document.createElement('div');
  modal.appendChild(host);
  parent.appendChild(modal);

  const close = (): void => {
    modal.close();
    modal.remove();
  };
  modal.addEventListener('close', () => {
    if (modal.isConnected) modal.remove();
  });
  render(host, close);
  enhanceSearchableSelects(host);
  modal.open();
}
